var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBringBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 1000 1000",
    viewBox: "0 0 1e3 1e3",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m990 990h-686v-686h686v686m-980-294v-686h686v680h-98v-582h-490v490h200v98z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 108.44,
    y: 108,
    width: 490,
    height: 490,
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBringBack);
export default __webpack_public_path__ + "static/media/bring-back.f3e5b295c7669daf95d499e8a0c9f690.svg";
export { ForwardRef as ReactComponent };